import { getRecommendations } from '@algolia/recommend-core';
import { useEffect, useRef, useState } from 'react';
import { useAlgoliaAgent } from './useAlgoliaAgent';
import { useStableValue } from './useStableValue';
import { useStatus } from './useStatus';
export function useRecommendations({
  fallbackParameters: userFallbackParameters,
  indexName,
  maxRecommendations,
  model,
  objectIDs: userObjectIDs,
  queryParameters: userQueryParameters,
  recommendClient,
  threshold,
  transformItems: userTransformItems = x => x
}) {
  const [result, setResult] = useState({
    recommendations: []
  });
  const {
    status,
    setStatus
  } = useStatus('loading');
  const objectIDs = useStableValue(userObjectIDs);
  const queryParameters = useStableValue(userQueryParameters);
  const fallbackParameters = useStableValue(userFallbackParameters);
  useAlgoliaAgent({
    recommendClient
  });
  const transformItemsRef = useRef(userTransformItems);
  useEffect(() => {
    transformItemsRef.current = userTransformItems;
  }, [userTransformItems]);
  useEffect(() => {
    setStatus('loading');
    getRecommendations({
      fallbackParameters,
      indexName,
      maxRecommendations,
      model,
      objectIDs,
      queryParameters,
      recommendClient,
      threshold,
      transformItems: transformItemsRef.current
    }).then(response => {
      setResult(response);
      setStatus('idle');
    });
  }, [fallbackParameters, indexName, maxRecommendations, model, objectIDs, queryParameters, recommendClient, setStatus, threshold]);
  return {
    ...result,
    status
  };
}